export default "__VITE_ASSET__F7P$ZKTo__"